export const SESSION_STORAGE_CLICK_PRODUCTS = "CPH:SESSION_STORAGE_CLICK_PRODUCTS"
export const SESSION_STORAGE_CLOSED_DESTINATION_MODAL = "CPH:CLOSED_DESTINATION_MODAL"
export const SESSION_STORAGE_DEPARTING_FLIGHTS = "CPH:DEPARTING_FLIGHTS"
export const SESSION_STORAGE_ARRIVING_FLIGHTS = "CPH:ARRIVING_FLIGHTS"
